import { connect } from 'react-redux';
import Bieres from '../../components/Bieres';

export default connect()(Bieres);
